{
  "name": "ll-admin-fe",
  "version": "4.5.1-develop.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "install": "cp ./package.json ./src/assets",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --coverage",
    "lint": "ng lint",
    "style-lint": "stylelint \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.8",
    "@angular/cdk": "^22.0.6",
    "@angular/common": "^22.0.8",
    "@angular/compiler": "^22.0.8",
    "@angular/core": "^22.0.8",
    "@angular/forms": "^22.0.8",
    "@angular/material": "^22.0.6",
    "@angular/platform-browser": "^22.0.8",
    "@angular/platform-browser-dynamic": "^22.0.8",
    "@angular/router": "^22.0.8",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.0.8",
    "@angular/cli": "^22.0.8",
    "@angular/compiler-cli": "^22.0.8",
    "@angular/language-service": "^22.0.8",
    "@angular/material-luxon-adapter": "^22.0.6",
    "@sparbanken-syd/auth-backend": "^2.6.5",
    "@sparbanken-syd/kalpylator": "^1.6.2",
    "@sparbanken-syd/loan-backend": "^4.10.0",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/user-documents-backend": "^1.2.0",
    "@types/jasmine": "~6.0.0",
    "@types/jmespath": "^0",
    "@types/luxon": "^3",
    "@types/node": "^24",
    "@vitest/coverage-v8": "^4.1.10",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.8.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~6.1.0",
    "jasmine-spec-reporter": "~7.0.0",
    "jmespath": "^0.16.0",
    "jsdom": "^29.1.1",
    "luxon": "^3.7.2",
    "postcss": "^8.5.8",
    "postcss-scss": "^4.0.9",
    "stylelint": "^17.5.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.57.2",
    "vitest": "^4.0.8"
  }
}
